import { useCallback } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'

import { columns } from './columns'
import { Filter } from './components'

export const HRRTable = () => {
  const { data, isTableLoading, onPageChange } = useAlertsContext()

  const {
    form: { highRiskReviewPage, highRiskReviewSize },
    showHighRiskReview,
    showHighRiskReviewTotalCount
  } = data

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'highRiskReview')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="High-Risk Review" anchor="hrr">
      <Layer rounded shadowed stretch>
        <Filter />
        <Table
          dataQa={TableDataQa.BP_ALERTS_HRR}
          columns={columns}
          dataSource={showHighRiskReview.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('highRiskReview')}
          pagination={{
            page: highRiskReviewPage || 1,
            size: highRiskReviewSize || 10,
            onChange: handlePageChange,
            total: showHighRiskReviewTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
}
